import { prune, type Draft } from './orders-search';

/**
 * The admin Reports screen's filters, in the URL for the same reason the
 * dashboard's are: a filtered window survives a refresh and can be pasted
 * into a message. Same shape as `DashboardSearch` — this screen is that
 * dashboard's historical twin — kept as its own type since the two routes
 * are free to diverge.
 */
export interface InsightsSearch {
    merchant?: number;
    city?: number;
    from?: string;
    to?: string;
}

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

function positiveInt(value: unknown): number | undefined {
    const parsed = Number(value);

    return Number.isInteger(parsed) && parsed > 0 ? parsed : undefined;
}

function isoDate(value: unknown): string | undefined {
    return typeof value === 'string' && ISO_DATE.test(value) ? value : undefined;
}

export function validateInsightsSearch(search: Record<string, unknown>): InsightsSearch {
    const { merchant, city, from, to } = search;

    return prune<InsightsSearch>({
        merchant: positiveInt(merchant),
        city: positiveInt(city),
        from: isoDate(from),
        to: isoDate(to),
    });
}

export type { Draft };
